import { Component  } from '@angular/core';
import { E5coreUiWorkFieldTypeTextBaseComponent } from './e5core-ui-work-field-type-text-base';

@Component({
  selector: 'e5core-ui-work-field-type-text-material',
  templateUrl: './e5core-ui-work-field-type-text-material.component.html',
  styleUrls: ['./e5core-ui-work-field-type-text-material.component.css']
})
export class E5coreUiWorkFieldTypeTextMaterialComponent extends E5coreUiWorkFieldTypeTextBaseComponent {
}
